export default defineAppConfig({
  site: {
    name: 'Echopus',
    defaultTitle: 'Echopus — Custom Web & Mobile App Development',
    description:
      'Echopus crafts custom web and mobile applications tailored to your business. From strategy and design to full development, we build impactful digital experiences.',
    locale: 'en_US',
    twitter: '@echoopus',
    defaultOgImage: '/og-image.png',
    // Full-screen "Echopus" intro over the first page of a session. Off: it replays over an
    // already-rendered page for ~3.5s, which Lighthouse scores as a slow Speed Index.
    intro: false,
  },
  // Seasonal New Year themes (gold accent, greeting, one-off particle effect). Each turns on by
  // itself inside its window, measured in `timeZone`. `force` pins one ('gregorian' | 'hijri')
  // or disables both (false); null follows the dates. Preview any time with ?season=gregorian.
  season: {
    timeZone: 'Asia/Riyadh',
    force: null as 'gregorian' | 'hijri' | false | null,
    // Month-day, inclusive; the window may wrap over Jan 1.
    gregorian: { enabled: true, from: '12-26', to: '01-07' },
    // First `days` days of Muharram, Umm al-Qura calendar.
    hijri: { enabled: true, days: 10 },
  },
})
